import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType, ref, watch } from 'vue';
import { ChecklistIntegerField } from '@/interfaces/components/configurator/ChecklistIntegerField';
import { EventBusEvents } from '@/enums/global/EventBusEvents';
import { validateAndFormatInteger } from '@/helpers/NumberFormatter';
import { EventBus } from '@/helpers/EventBusHelper';
import store from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'ChecklistIntegerFieldModule',
  props: {
    checklistIntegerField: { type: Object as PropType<ChecklistIntegerField>, required: true },
    pId: { type: String, required: true },
    debounceToggleIsActive: {
        type: Function as PropType<(state: boolean) => void>,
        default: null,
    },
    activeProductFormId: { type: Number, default: null },
},
  emits: ['updateStoreFieldValue'],
  setup(__props, { emit }) {

const props = __props;





const value = ref<number | null>(props.checklistIntegerField.defaultValue);

const fieldValue = computed(() => {
    if (props.activeProductFormId == null) {
        return props.checklistIntegerField.min;
    }

    return store.getters['configurator/activeProductFormValue'](props.pId, props.activeProductFormId) as number | null;
});

function onBlur(a: any) {
    if (value.value === null) {
        onChange(1);
    }

    if (value.value !== fieldValue.value || props.activeProductFormId == null) {
        onChange(value.value);
    }

    props.debounceToggleIsActive && props.debounceToggleIsActive(false);
}

function onFocus() {
    window.setTimeout(() => {
        props.debounceToggleIsActive && props.debounceToggleIsActive(true);
    }, 200);
}

function onChange(newValue: number | null) {
    EventBus.$emit(EventBusEvents.changesInDataMade, { state: true });

    emit(EventBusEvents.updateStoreFieldValue, {
        pId: props.pId,
        value: validateAndFormatInteger(newValue, props.checklistIntegerField.min, props.checklistIntegerField.max),
        productFormId: props.activeProductFormId,
    });
}

watch(
    fieldValue,
    (newValue: number | null) => {
        value.value = validateAndFormatInteger(
            newValue,
            props.checklistIntegerField.min,
            props.checklistIntegerField.max,
        );
    },
    { immediate: true },
);

function formatNumber(value: number | string | null): number {
    return validateAndFormatInteger(value, props.checklistIntegerField.min, props.checklistIntegerField.max);
}

return { __sfc: true,props, emit, value, fieldValue, onBlur, onFocus, onChange, formatNumber }
}

})